import { Component, OnInit } from "@angular/core";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import {
  FormBuilder,
  Validators,
  AbstractControl,
  FormControl,
  FormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { DatePipe } from "@angular/common";
import { CommonService } from "app/_services/common.service";

@Component({
  selector: "app-taxreturn-expertise",
  templateUrl: "./taxreturn-expertise.component.html",
  styleUrls: ["./taxreturn-expertise.component.css"],
})
export class TaxreturnExpertiseComponent implements OnInit {
  public rentalIncome;
  public royalties;
  public americorp;
  public box3Others;
  public landlord;
  public mortgageDebt;
  public citizen;
  public resident;
  public foreignCountry;
  public military;
  public veteran;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    if (
      this.rentalIncome != null &&
      this.royalties != null &&
      this.americorp != null &&
      this.box3Others != null &&
      this.landlord != null &&
      this.mortgageDebt != null &&
      this.citizen != null &&
      this.resident != null &&
      this.foreignCountry != null &&
      this.military != null &&
      this.veteran != null
    ) {
      console.log("taxreturn expertise");
      //         Select Site
      // (Logic for Site
      // Selection)

      // Appointment Plus
      // Drop Off Appointment

      // Appointment Plus
      // Tax Signing Appointment

      // DB: Location; Appointment 1
      // & 2 Date and Time
    } else {
      alert("Please fill all the details");
    }
  }

  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }
}
